export default [
	{
		type: 'Subaru Express Service',
		selector:
			'.ws-subaru-prgrm-logos a[href*="/subaru-express-service.htm"]'
	},
	{
		type: 'Trade Up Advantage',
		selector: '.ws-subaru-prgrm-logos a[href*="/trade-up-advantage.htm"]'
	},
	{
		type: 'Certified Subaru Eco-Friendly Retailer',
		selector:
			'.ws-subaru-prgrm-logos a[href*="/eco-friendly-retailer-program.htm"]'
	},
	{
		type: 'CPO Logo',
		selector:
			'.ws-subaru-prgrm-logos a[href*="/certified-inventory/index.htm"]'
	},
	{
		type: 'Retailer Program Widget',
		selector: '.ws-subaru-prgrm-logos a'
	},
	{
		type: '2022 Subaru Outback Wilderness',
		selector:
			'.v9-oem-subaru-0001-v1 .ddc-footer-secondary ul.jcarousel-list li > a[href="/2022-subaru-outback-wilderness-launch.htm"]'
	},
	{
		type: 'Subaru Consumer Reports',
		selector:
			'.v9-oem-subaru-0001-v1 .ddc-footer-secondary ul.jcarousel-list li > a[href="/consumer-reports.htm"]'
	},
	{
		type: 'Industry Reviews & Awards',
		selector:
			'.v9-oem-subaru-0001-v1 .ddc-footer-secondary ul.jcarousel-list li > a[href="/subaru-awards.htm"]'
	},
	{
		type: 'Subaru Incentives, Rebates, Specials',
		selector:
			'.v9-oem-subaru-0001-v1 .ddc-footer-secondary ul.jcarousel-list li > a[href="/global-incentives/index.htm"]'
	},
	{
		type: 'Meet the Barkleys',
		selector:
			'.v9-oem-subaru-0001-v1 .ddc-footer-secondary ul.jcarousel-list li > a[href="/meet-the-barkleys.htm"]'
	},
	{
		type: 'Love Promise',
		selector:
			'.v9-oem-subaru-0001-v1 .ddc-footer-secondary ul.jcarousel-list li > a[href="/subaru-love-promise.htm"]'
	},
	{
		type: 'Corporate Cell Cards',
		selector:
			'.v9-oem-subaru-0001-v1 .ddc-footer-secondary ul.jcarousel-list li > a'
	},
	{
		type: 'aspca',
		selector: '.ws-subaru-stl #aspca a.national-charity-btn'
	},
	{
		type: 'maw',
		selector: '.ws-subaru-stl #maw a.national-charity-btn'
	},
	{
		type: 'mow',
		selector: '.ws-subaru-stl #monw a.national-charity-btn'
	},
	{
		type: 'npf',
		selector: '.ws-subaru-stl #npf a.national-charity-btn'
	},
	{
		type: 'hometown',
		selector:
			'.ws-subaru-stl a[href*="/share-the-love/submission-form.html"]'
	},
	{
		type: 'Share The Love',
		selector: '.ws-subaru-stl a.national-charity-btn'
	},
	{
		type: 'Awards and Accolades',
		selector: '[data-web-api-id="subaruawards-badgeprice"] a'
	},
	{
		type: 'Starlink',
		selector: 'a.subaru-starlink, .subaru-starlink a'
	},
	{
		type: 'Eyesight',
		selector: 'a.subaru-eyesight, .subaru-eyesight a'
	},
	{
		events: 'scheduleServiceClick',
		type: 'Schedule Service',
		selector: ['.subaru-service-button a']
	}
];
